import React from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import {ArrowRightCircle} from "react-bootstrap-icons"
import headerImg from '../assets/img/header-img.svg'
import {Qualifications, Biography} from '../constant'

const Banner = () => {
    const [loopNumb, setLoopNumb] = React.useState(0)
    const [isDeleting, setIsDeleting] = React.useState(false)
    const toType = Qualifications
    const [letter, setLetter] = React.useState('')
    const [delta, setDelta] = React.useState(300 - Math.round() * 100)
    const period = 2000

    const tick = () => {
        let i = loopNumb % toType.length
        let fullText = toType[i]
        let updatedText = isDeleting ? fullText.substring(0, letter.length - 1) : fullText.substring(0, letter.length + 1)
        setLetter(updatedText)

        if(isDeleting) {
            setDelta(prevDelta => prevDelta / 2)
        }

        if(!isDeleting && updatedText === fullText) {
            setIsDeleting(true)
            setDelta(period)
        }else if(isDeleting && updatedText === ''){
            setIsDeleting(false)
            setLoopNumb(loopNumb + 1)
            setDelta(500)
        } 
    }

    React.useEffect(() => {
        let ticker = setInterval(() => {
            tick()
        }, delta)

        return () => { clearInterval(ticker) }
    }, [letter])


    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={7} data-zanim-timeline="{}" data-zanim-trigger="scroll">
                        <span className="tagline text-center" data-zanim-xs='{"delay": 0.2, "animation": "slide-right"}'>
                            Bienvenue sur mon portefeuille
                            <h1>
                                {`Salut je suis Orlando `}
                                <span className='wrap'>{letter}</span>
                            </h1>
                            <p>
                                {Biography}
                            </p>
                            <a href="/curriculom" target="__blank">Jetez un coup d'oeil à mon CV<ArrowRightCircle size={25} /></a>
                        </span>
                    </Col>
                    <Col xs={12} md={6} xl={5} data-zanim-lg='{"animation":"zoom-out","delay":0}' data-zanim-trigger="scroll">
                        <img src={headerImg} alt="Header Img" />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
export default Banner;
